import React from 'react';
import Loader from '../UI/Loader/Loader';
import { Formik, Form } from 'formik';
import { FormikInput, PrimaryButton } from "../UI";
import PrimaryModal from '../UI/Modal/PrimaryModal';
import * as Yup from 'yup';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const TemplateNameSchema = Yup.object().shape({
  template_name: Yup.string().required('Template name is required'),
});

const TemplateNameModal = ({
  hideModal,
  initialName,
  setName,
  onSubmit,
  loading,
  error
}) => {
  const { content } = useContentfulContext();

  return (
    <PrimaryModal title={content.MANAGE_TEMPLATE_CONTENT.table_headers.template_name} hideModal={hideModal}>
      <div className="p-6 space-y-6">
        {loading && <Loader />}
        <Formik
          initialValues={{ template_name: initialName }}
          validationSchema={TemplateNameSchema}
          onSubmit={onSubmit}
        >
          {() => (
            <Form className="space-y-4 md:space-y-6">
              <FormikInput
                id="template_name"
                name="template_name"
                label={content.MANAGE_TEMPLATE_CONTENT.form.name}
                placeholder={content.MANAGE_TEMPLATE_CONTENT.form.name}
                onChange={(e) => setName(e.target.value)}
                mandatory
              />

              {error && <p className="text-base text-red-500">{error}</p>}

              <div className="flex items-center justify-end space-x-2">
                <PrimaryButton id="save-template-name" type="submit">
                {/* {content.MANAGE_TEMPLATE_CONTENT.save} */}Save
                </PrimaryButton>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </PrimaryModal>
  );
};

export default TemplateNameModal;
